var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartBarSolid({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.9375 1.25C1.44531 1.25 1.875 1.67969 1.875 2.1875V15.9375C1.875 16.4844 2.26562 16.875 2.8125 16.875H19.0625C19.5703 16.875 20 17.3047 20 17.8125C20 18.3594 19.5703 18.75 19.0625 18.75H2.8125C1.25 18.75 0 17.5 0 15.9375V2.1875C0 1.67969 0.390625 1.25 0.9375 1.25ZM5 5.3125C5 4.80469 5.39062 4.375 5.9375 4.375H14.0625C14.5703 4.375 15 4.80469 15 5.3125C15 5.85938 14.5703 6.25 14.0625 6.25H5.9375C5.39062 6.25 5 5.85938 5 5.3125ZM11.5625 8.125C12.0703 8.125 12.5 8.55469 12.5 9.0625C12.5 9.60938 12.0703 10 11.5625 10H5.9375C5.39062 10 5 9.60938 5 9.0625C5 8.55469 5.39062 8.125 5.9375 8.125H11.5625ZM16.5625 11.875C17.0703 11.875 17.5 12.3047 17.5 12.8125C17.5 13.3594 17.0703 13.75 16.5625 13.75H5.9375C5.39062 13.75 5 13.3594 5 12.8125C5 12.3047 5.39062 11.875 5.9375 11.875H16.5625Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartBarSolid);
export default __webpack_public_path__ + "static/media/ChartBarSolid.1066a1569cb8c02e9ef54a16a5f719f2.svg";
export { ForwardRef as ReactComponent };